/** 상자 230×300(꼭지 포함 313) — 상자 안쪽 여백 10 · 테두리 2 를 뺀 내용 자리. 토큰에 없는 값이라 인라인 style */
export const NOTIFICATION_POPOVER_CONTENT_PX = { width: 206, height: 276 } as const;
/** 바닥에서 이만큼 안에 들어오면 다음 쪽을 부른다 */
export const NOTIFICATION_SCROLL_END_PX = 10;
